module.exports = __webpack_public_path__ + "img/facebook.b9173756.svg";